export function getRandomArrayItem<T>(array: T[]) {
  const randomIndex = Math.floor(Math.random() * array.length);
  return array[randomIndex];
}

export const EXAMPLE1 =
  'Sorteio dia dos namorados\nSorteio dia 11/06/2021 às 16:00\n\nComo participar:\nPara participar basta baixar o Cliquei Achei na Play Store, Appstore ou em https://cliqueiachei.com.br/aplicativos, curtir a imagem da promoção no Storie do aplicativo e aguardar a data do sorteio. Boa sorte!\n\nConcorra a:\n1 Quer ganhar essa linda cestinha para curtir com seu amor? É só clicar em participar e boa sorte.\n\nRegulamento do Cliquei Achei\nO ganhador será desclassificado e perderá o direito ao prêmio caso o WhatsApp informado no aplicativo Cliquei Achei esteja errado, pois usamos o WhatsApp como forma de validar a identidade do ganhador no momento do sorteio.\nSomente moradores de Passos (MG) podem participar.\nO ganhador deve retirar o prêmio no local.\nNão enviaremos o prêmio para outra cidade que não seja Passos (MG).';

export const EXAMPLE2 =
  'Sorteio Dia Dos Namorados ❤️\nSorteio dia 10/06/2021 às 21:00\n\nComo participar:\nPara participar basta baixar o Cliquei Achei na Play Store, Appstore ou em https://cliqueiachei.com.br/aplicativos, curtir a imagem da promoção no Storie do aplicativo e aguardar a data do sorteio. Boa sorte!\n\nConcorra a:\n1 Combo Lupanda\n\nRegulamento do Cliquei Achei\nO ganhador será desclassificado e perderá o direito ao prêmio caso o WhatsApp informado no aplicativo Cliquei Achei esteja errado, pois usamos o WhatsApp como forma de validar a identidade do ganhador no momento do sorteio.\nSomente moradores de Passos (MG) podem participar.\nO ganhador deve retirar o prêmio no local.\nNão enviaremos o prêmio para outra cidade que não seja Passos (MG).';

type Prize = {
  amount: number;
  description: string;
};

export function extractPromotionPrizes(promotionText: string) {
  const initialSearchTarget = 'Concorra a:';
  const initialIndex = promotionText.indexOf(initialSearchTarget) + initialSearchTarget.length;

  const finalSearchTarget = 'Regulamento do Cliquei Achei';
  const finalIndex = promotionText.indexOf(finalSearchTarget);

  const prizesTexts = promotionText.substring(initialIndex, finalIndex);
  const prizes = prizesTexts
    .split('\n')
    .filter(filterEmptyText)
    .map((prizeText) => {
      const firstSpaceIndex = prizeText.indexOf(' ');
      const amountAsString = prizeText.substring(0, firstSpaceIndex).trim();
      const amount = amountAsString ? Number(amountAsString) : 1;

      const description = prizeText.substring(firstSpaceIndex).trim();
      return { amount, description } as Prize;
    });
  return prizes;

  function filterEmptyText(text: string) {
    return text.trim().length > 0;
  }
}

export function createPromotionMessage(prizes: Prize[], storyOwnerName: string) {
  let prizesText = '';
  if (prizes.length === 1) {
    prizesText = `${prizes[0].amount} ${prizes[0].description}`;
  } else {
    prizes.map((prize, index) => {
      if (index === 0) return `${prize.amount} ${prize.description}`;
      if (index === prizes.length - 1) return `e ${prize.amount} ${prize.description}`;
      return `, ${prize.amount} ${prize.description}`;
    });
  }

  return `Tá rolando o sorteio de <strong>${prizesText}</strong> da <strong>${storyOwnerName}</strong> no aplicativo. Instale para participar e fazer seus próximos pedidos pelo app!`;
}
